import { BrowserCacheLocation, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";
import { AuthConfig } from "./config";

export function createMsalInstance(config: AuthConfig): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      knownAuthorities: config.knownAuthorities,
      redirectUri: config.redirectUri,
      postLogoutRedirectUri: config.postLogoutRedirectUri,
    },
    cache: { cacheLocation: BrowserCacheLocation.SessionStorage },
  });
}
